import { Row, Col } from 'antd';
import styled from 'styled-components';

export const WorkshopRow = styled(Row)`
  margin-bottom: 25px;
  @media (max-width: 768px) {
    padding-bottom: 25px;
  }
  border-bottom: 1px solid #cfd8dc;
  .image-row {
    display: none;
  }
  &.grid {
    .image-row {
      display: inline;
    }
    border-bottom: none;

    .workshop-content {
      box-shadow: 0px 15px 40px 0px #00000040;
      padding: 30px;
      > div {
        padding-right: 0;
      }
      .content-container {
        height: 260px;
      }
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 8;
        overflow: hidden;
      }
      .Helm-Icon > svg {
        display: none;
      }
      .Video__playButton {
        padding: 16px 12px;
      }
    }
  }
`;

export const WorkshopContentCol = styled(Col)`
  @media (min-width: 769px) {
    padding-right: 150px;
  }
`;

export const VideoCol = styled(Col)`
  text-align: right;
  @media (max-width: 768px) {
    text-align: center;
  }
  .Video__playButton {
    padding: 28px 0px;
    @media (max-width: 768px) {
      padding: 17px 0;
    }
    > span {
      font-size: 16px;
    }
  }
  svg {
    width: 12px;
    height: 12px;
  }
  .Helm-Icon {
    line-height: 100%;
    @media (max-width: 768px) {
      > svg {
        display: none;
      }
    }
  }
`;
